import { SimpleTooltip } from '~/sotano-kit/primitives/tooltip'
import { ChangesBehindIcon } from '../../tab-content/branch-manager'
import { clsx } from 'clsx'

export const BranchMergeDiff = ({
  behind,
  ahead,
  className,
}: {
  behind: number
  ahead: number
  className?: string
}) => {
  return (
    <div className={clsx('font-medium gap-1 flex', className)}>
      <SimpleTooltip
        content={`${behind} ${behind === 1 ? 'commit' : 'commits'} behind`}
        asChild
      >
        <div className="text-dark-muted text-xs bg-dark-shade px-1.5 inline-flex items-center gap-1 rounded">
          <span>{behind}</span>
          <ChangesBehindIcon />
        </div>
      </SimpleTooltip>
      <SimpleTooltip
        asChild
        content={`${ahead} ${ahead === 1 ? 'commit' : 'commits'} ahead`}
      >
        <div className="text-dark-muted text-xs bg-dark-shade px-1.5 inline-flex items-center gap-1 rounded">
          <ChangesBehindIcon className="rotate-180" />
          <span>{ahead}</span>
        </div>
      </SimpleTooltip>
    </div>
  )
}
